var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "md-dialog",
        {
          attrs: { "md-active": _vm.showDialog },
          on: {
            "update:mdActive": function($event) {
              _vm.showDialog = $event
            },
            "update:md-active": function($event) {
              _vm.showDialog = $event
            }
          }
        },
        [
          _c("md-dialog-title", [_vm._v("Search Advisers")]),
          _vm._v(" "),
          _c(
            "md-field",
            { staticClass: "searcher" },
            [
              _c("label", [_vm._v("Existing advisers name or email")]),
              _vm._v(" "),
              _c("md-input", {
                on: { keyup: _vm.quickSearch, input: _vm.sanitizeSearch },
                model: {
                  value: _vm.searchText,
                  callback: function($$v) {
                    _vm.searchText = $$v
                  },
                  expression: "searchText"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.searchResults.length > 0
            ? _c(
                "multi-member-picker",
                {
                  attrs: {
                    members: _vm.searchResults,
                    selected: _vm.selected,
                    admin: _vm.selectionProp,
                    iconName: _vm.iconName
                  },
                  on: { changed: _vm.updateSelected }
                },
                [_vm._v("Advisors goes here...")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "md-dialog-actions",
            [
              _c(
                "md-button",
                {
                  staticClass: "md-primary",
                  on: {
                    click: function($event) {
                      return _vm.cancel()
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "md-button",
                {
                  staticClass: "md-primary",
                  attrs: { disabled: _vm.selected.length <= 0 },
                  on: {
                    click: function($event) {
                      return _vm.choose()
                    }
                  }
                },
                [_vm._v("Choose")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "picker-icon picker-name",
          on: {
            click: function($event) {
              _vm.showDialog = true
            }
          }
        },
        [
          _c("font-awesome-icon", {
            staticClass: "small-icon",
            attrs: { icon: "plus-circle" }
          }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.iconName))])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-97ab7766", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97ab7766","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShowAdviser.vue
// module id = null
// module chunks = 